var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeat2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3a5 5 0 000 10h4a5 5 0 000-10H6zm4.46 8.5v-.938H7.18l1.538-1.694c.215-.221.412-.44.59-.654.18-.218.334-.435.464-.65a3.12 3.12 0 00.308-.654c.072-.218.107-.438.107-.659 0-.4-.087-.747-.263-1.04a1.711 1.711 0 00-.757-.679c-.332-.16-.736-.239-1.21-.239-.505 0-.937.103-1.295.308a2.071 2.071 0 00-.82.82c-.189.342-.283.72-.283 1.133h1.176c0-.257.046-.485.137-.684.091-.202.226-.36.405-.474.18-.113.4-.17.664-.17.228 0 .422.05.581.15.16.099.28.234.362.406.084.17.127.366.127.591 0 .16-.031.324-.093.493a2.397 2.397 0 01-.308.562 8.759 8.759 0 01-.6.742l-2.315 2.524v.806h4.766z",
    fill: "#D70022"
  })));
}
SvgSeat2.displayName = 'Seat2';
export default SvgSeat2;